import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment-timezone";
import _ from "lodash";
import Button from "react-bootstrap-button-loader";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { COMMON_FAIL_MESSAGE, DEVELOPMENT_TYPE } from "Constants";
import {
  updatedEventSetting,
  updateTimeZone,
  changeSpeakerSort,
  changeSponsorSort,
  changeExhibitorSort,
  changeGalleryUploadPermission,
  changeNotificationStatus,
  changeAppBottomMenuStatus,
  changeSocialLogin,
  changeAutologinStatus,
  changeloginMandatoryStatus,
  changeMultipleLoginStatus,
  updateEventSettingOption,
  changeWaitlistmode,
  changeScheduleview,
  changeUserfilesdownloadable,
  changeSpeakerfilesdownloadable,
  changeSponsorfilesdownloadable,
  changeExhibitorfilesdownloadable,
  changeSessionfilesdownloadable,
} from "SettingActions";
import { fetchSettings } from "TicketAction";
import { fetchEvent } from "ActionsMessage";
import { fetchFeature } from "GeneralTabAction";
import { showError, showSuccess } from "ReduxErrorBar";
import TimeZoneSelect from "TimeZoneSelect";
import LocaleStrings from "Languages";

class EventSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timezone: "",
      loadingtimezone: false,
      loadingspeakesort: false,
      loadingsponsorsort: false,
      loadingexhibitorsort: false,
      loadinggalleryupload: false,
      loadingnotificationstatus: false,
      loadingappbottommenu: false,
      loadingsociallogin: false,
      loadingautologin: false,
      loadingloginmandatory: false,
      loadingmultiplelogin: false,
      notificationblocker: false,
      overviewscreenswitcher: false,
      eventcodelogin: false,
      loadingaccesswhitelabelapp: false,
      loadingwaitlistmode: false,
      loadingscheduleview: false,
      loadingspeakerview: false,
      loadingspeakerprofileshare: false,
      loadinguserfilesdownloadable: false,
      loadingspeakerfilesdownloadable: false,
      loadingsponsorfilesdownloadable: false,
      loadingexhibitorfilesdownloadable: false,
      loadingsessionfilesdownloadable: false,
    };
  }

  componentDidMount() {
    this.props.fetchFeature(this.props.session);
  }
  // Update Timezone
  updatetimezone = (value) => {
    this.setState({ timezone: value });
  };

  handleEventTimezone = () => {
    let { session, eventData } = this.props;
    let { timezone } = this.state;
    let values = { eventid: eventData[0].eventid, eventtimezone: timezone };
    let message = LocaleStrings.event_setting_alert_timezone_update_success;

    this.setState({ loadingtimezone: true });
    this.props.updateTimeZone(session, values, (response) => {
      if (response.success) {
        this.props.fetchEvent(session, (res) => {
          this.setState({ loadingtimezone: false, timezone: "" });
          this.props.showSuccess(message);
        });
      } else {
        this.setState({ loadingtimezone: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    });
  };

  handleSpeakerSort = () => {
    let { session, settingData } = this.props;
    let option = "randomly";
    let message = LocaleStrings.event_setting_alert_speaker_sort_randomly;

    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].speakersort === "randomly"
    ) {
      option = "az";
      message = LocaleStrings.event_setting_alert_speaker_sort_az;
    }

    this.setState({ loadingspeakesort: true });
    this.props.changeSpeakerSort(
      session,
      option,
      settingData[0].id,
      (response) => {
        if (response.success) {
          this.props.fetchSettings(session, (res) => {
            this.setState({ loadingspeakesort: false });
            this.props.showSuccess(message);
          });
        } else {
          this.setState({ loadingspeakesort: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  handleSponsorSort = () => {
    let { session, settingData } = this.props;
    let option = "randomly";
    let message = LocaleStrings.event_setting_alert_sponsor_sort_randomly;

    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].sponsorsort === "randomly"
    ) {
      option = "az";
      message = LocaleStrings.event_setting_alert_sponsor_sort_az;
    }

    this.setState({ loadingsponsorsort: true });
    this.props.changeSponsorSort(
      session,
      option,
      settingData[0].id,
      (response) => {
        if (response.success) {
          this.props.fetchSettings(session, (res) => {
            this.setState({ loadingsponsorsort: false });
            this.props.showSuccess(message);
          });
        } else {
          this.setState({ loadingsponsorsort: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  handleExhibitorSort = () => {
    let { session, settingData } = this.props;
    let option = "randomly";
    let message = LocaleStrings.event_setting_alert_exhibitor_sort_randomly;

    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].exhibitorsort === "randomly"
    ) {
      option = "az";
      message = LocaleStrings.event_setting_alert_exhibitor_sort_az;
    }

    this.setState({ loadingexhibitorsort: true });
    this.props.changeExhibitorSort(
      session,
      option,
      settingData[0].id,
      (response) => {
        if (response.success) {
          this.props.fetchSettings(session, (res) => {
            this.setState({ loadingexhibitorsort: false });
            this.props.showSuccess(message);
          });
        } else {
          this.setState({ loadingexhibitorsort: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  handleGalleryUpload = () => {
    var { session, settingData } = this.props;
    let option = 0;
    let message =
      LocaleStrings.basic_setting_alert_gallery_pic_upload_deactivated;
    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].galleryimage == false
    ) {
      option = 1;
      message = LocaleStrings.basic_setting_alert_gallery_pic_upload_activated;
    }

    this.setState({ loadinggalleryupload: true });
    this.props.changeGalleryUploadPermission(
      session,
      option,
      settingData[0].id,
      (response) => {
        if (response.success) {
          this.props.fetchSettings(session, (res) => {
            this.setState({ loadinggalleryupload: false });
            this.props.showSuccess(message);
          });
        } else {
          this.setState({ loadinggalleryupload: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  handleNotification = () => {
    var { session, settingData } = this.props;
    let option = 0;
    let message =
      LocaleStrings.basic_setting_alert_notification_on_purchase_deactivated;
    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].notificationonticketpurchase == false
    ) {
      option = 1;
      message =
        LocaleStrings.basic_setting_alert_notification_on_purchase_activated;
    }

    this.setState({ loadingnotificationstatus: true });
    this.props.changeNotificationStatus(
      session,
      option,
      settingData[0].id,
      (response) => {
        if (response.success) {
          this.props.fetchSettings(session, (res) => {
            this.setState({ loadingnotificationstatus: false });
            this.props.showSuccess(message);
          });
        } else {
          this.setState({ loadingnotificationstatus: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  handleAppBottomMenu = () => {
    var { session, settingData } = this.props;
    let option = 0;
    let message = LocaleStrings.basic_setting_alert_app_bottom_menu_deactivated;
    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].isbottommenuactive == false
    ) {
      option = 1;
      message = LocaleStrings.basic_setting_alert_app_bottom_menu_activated;
    }

    this.setState({ loadingappbottommenu: true });
    this.props.changeAppBottomMenuStatus(
      session,
      option,
      settingData[0].id,
      (response) => {
        if (response.success) {
          this.props.fetchSettings(session, (res) => {
            this.setState({ loadingappbottommenu: false });
            this.props.showSuccess(message);
          });
        } else {
          this.setState({ loadingappbottommenu: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  handleSocialLogin = () => {
    var { session, eventData } = this.props;
    let option = 0;
    let message = LocaleStrings.bacis_setting_alert_sociallogin_deactivated;
    if (
      eventData &&
      eventData.length > 0 &&
      eventData[0].sociallogin == false
    ) {
      option = 1;
      message = LocaleStrings.basic_setting_alert_sociallogin_activated;
    }

    this.setState({ loadingsociallogin: true });
    this.props.changeSocialLogin(session, option, (response) => {
      if (response.success) {
        this.props.fetchEvent(session, (res) => {
          this.setState({ loadingsociallogin: false });
          this.props.showSuccess(message);
        });
      } else {
        this.setState({ loadingsociallogin: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    });
  };

  handleAutoLogin = () => {
    var { session, settingData } = this.props;
    let option = 0;
    let message = LocaleStrings.basic_setting_alert_autologin_deactivated;
    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].autologin == false
    ) {
      option = 1;
      message = LocaleStrings.basic_setting_alert_autologin_activated;
    }

    this.setState({ loadingautologin: true });
    this.props.changeAutologinStatus(
      session,
      option,
      settingData[0].id,
      (response) => {
        if (response.success) {
          this.props.fetchSettings(session, (res) => {
            this.setState({ loadingautologin: false });
            this.props.showSuccess(message);
          });
        } else {
          this.setState({ loadingautologin: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  handleMandatoryLogin = () => {
    var { session, settingData } = this.props;
    let option = 0;
    let message = LocaleStrings.basic_setting_alert_login_mandatory_deactivated;
    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].isloginmandatory == false
    ) {
      option = 1;
      message = LocaleStrings.basic_setting_alert_login_mandatory_activated;
    }

    this.setState({ loadingloginmandatory: true });
    this.props.changeloginMandatoryStatus(
      session,
      option,
      settingData[0].id,
      (response) => {
        if (response.success) {
          this.props.fetchSettings(session, (res) => {
            this.setState({ loadingloginmandatory: false });
            this.props.showSuccess(message);
          });
        } else {
          this.setState({ loadingloginmandatory: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  handleMultipleLogin = () => {
    var { session, settingData } = this.props;
    let option = 0;
    let message = LocaleStrings.basic_setting_alert_multiple_login_deactivated;
    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].allowmultiplelogin == false
    ) {
      option = 1;
      message = LocaleStrings.basic_setting_alert_multiple_login_activated;
    }

    this.setState({ loadingmultiplelogin: true });
    this.props.changeMultipleLoginStatus(
      session,
      option,
      settingData[0].id,
      (response) => {
        if (response.success) {
          this.props.fetchSettings(session, (res) => {
            this.setState({ loadingmultiplelogin: false });
            this.props.showSuccess(message);
          });
        } else {
          this.setState({ loadingmultiplelogin: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  handleNotificationBlocker = () => {
    var { session, settingData } = this.props;
    let option = 0;
    let message =
      LocaleStrings.basic_setting_alert_notification_blocker_deactivated;
    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].notificationblocker == false
    ) {
      option = 1;
      message =
        LocaleStrings.basic_setting_alert_notification_blocker_activated;
    }
    let values = { id: settingData[0].id, notificationblocker: option };

    this.setState({ notificationblocker: true });
    this.props.updateEventSettingOption(session, values, (response) => {
      if (response.success) {
        this.props.fetchSettings(session, (res) => {
          this.setState({ notificationblocker: false });
          this.props.showSuccess(message);
        });
      } else {
        this.setState({ notificationblocker: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    });
  };

  handleScreenSwitcher = () => {
    var { session, settingData } = this.props;
    let option = 0;
    let message =
      LocaleStrings.basic_setting_alert_overview_screen_switcher_deactivated;
    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].showquicklinksonhome == false
    ) {
      option = 1;
      message =
        LocaleStrings.basic_setting_alert_overview_screen_switcher_activated;
    }
    let values = { id: settingData[0].id, showquicklinksonhome: option };

    this.setState({ overviewscreenswitcher: true });
    this.props.updateEventSettingOption(session, values, (response) => {
      if (response.success) {
        this.props.fetchSettings(session, (res) => {
          this.setState({ overviewscreenswitcher: false });
          this.props.showSuccess(message);
        });
      } else {
        this.setState({ overviewscreenswitcher: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    });
  };

  handleEventCodeLogin = () => {
    var { session, settingData } = this.props;
    let option = 0;
    let message = LocaleStrings.basic_setting_alert_eventcode_login_deactivated;
    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].eventcodelogin == false
    ) {
      option = 1;
      message = LocaleStrings.basic_setting_alert_eventcode_login_activated;
    }
    let values = { id: settingData[0].id, eventcodelogin: option };

    this.setState({ eventcodelogin: true });
    this.props.updateEventSettingOption(session, values, (response) => {
      if (response.success) {
        this.props.fetchSettings(session, (res) => {
          this.setState({ eventcodelogin: false });
          this.props.showSuccess(message);
        });
      } else {
        this.setState({ eventcodelogin: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    });
  };

  handleWhiteLabelAppAccess = () => {
    var { session, settingData } = this.props;
    let option = 0;
    let message =
      LocaleStrings.basic_setting_alert_whitelabel_app_permission_taken;
    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].accesswhitelabelapp == false
    ) {
      option = 1;
      message =
        LocaleStrings.basic_setting_alert_whitelabel_app_permission_given;
    }
    let values = { id: settingData[0].id, accesswhitelabelapp: option };

    this.setState({ loadingaccesswhitelabelapp: true });
    this.props.updateEventSettingOption(session, values, (response) => {
      if (response.success) {
        this.props.fetchSettings(session, (res) => {
          this.setState({ loadingaccesswhitelabelapp: false });
          this.props.showSuccess(message);
        });
      } else {
        this.setState({ loadingaccesswhitelabelapp: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    });
  };

  handleWaitlistMode = () => {
    var { session, settingData } = this.props;
    let option = 0;
    let message = LocaleStrings.basic_setting_alert_waitlist_mode_deactivated;
    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].waitlistmode == false
    ) {
      option = 1;
      message = LocaleStrings.basic_setting_alert_waitlist_option_activated;
    }

    this.setState({ loadingwaitlistmode: true });
    this.props.changeWaitlistmode(
      session,
      option,
      settingData[0].id,
      (response) => {
        if (response.success) {
          this.props.fetchSettings(session, (res) => {
            this.setState({ loadingwaitlistmode: false });
            this.props.showSuccess(message);
          });
        } else {
          this.setState({ loadingwaitlistmode: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  handleScheduleStatus = () => {
    var { session, settingData } = this.props;
    let option = "calendar";
    let message = LocaleStrings.basic_setting_alert_scheduleview_calendar;
    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].scheduleview == "calendar"
    ) {
      option = "grid";
      message = LocaleStrings.basic_setting_alert_scheduleview_grid;
    }

    this.setState({ loadingscheduleview: true });
    this.props.changeScheduleview(
      session,
      option,
      settingData[0].id,
      (response) => {
        if (response.success) {
          this.props.fetchSettings(session, (res) => {
            this.setState({ loadingscheduleview: false });
            this.props.showSuccess(message);
          });
        } else {
          this.setState({ loadingscheduleview: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  handleSpeakerView = () => {
    var { session, settingData } = this.props;
    let option = 1;
    let message = LocaleStrings.basic_setting_alert_speakerview_list;
    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].speakerlistview == true
    ) {
      option = 0;
      message = LocaleStrings.basic_setting_alert_speakerview_grid;
    }

    let values = {
      id: settingData[0].id,
      speakerlistview: option,
      eventid: session.eventid,
    };

    this.setState({ loadingspeakerview: true });
    this.props.updatedEventSetting(session, values, (response) => {
      if (response.success) {
        this.props.fetchSettings(session, (res) => {
          this.setState({ loadingspeakerview: false });
          this.props.showSuccess(message);
        });
      } else {
        this.setState({ loadingspeakerview: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    });
  };

  handleSpeakerProfileShare = () => {
    var { session, settingData } = this.props;
    let option = 1;
    let message = LocaleStrings.basic_setting_alert_speaker_profile_share_on;
    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].speakerprofileshare == true
    ) {
      option = 0;
      message = LocaleStrings.basic_setting_alert_speaker_profile_share_off;
    }

    let values = {
      id: settingData[0].id,
      speakerprofileshare: option,
      eventid: session.eventid,
    };

    this.setState({ loadingspeakerprofileshare: true });
    this.props.updatedEventSetting(session, values, (response) => {
      if (response.success) {
        this.props.fetchSettings(session, (res) => {
          this.setState({ loadingspeakerprofileshare: false });
          this.props.showSuccess(message);
        });
      } else {
        this.setState({ loadingspeakerprofileshare: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    });
  };

  handleUserfilesdownloadable = () => {
    var { session, settingData } = this.props;
    let option = 0;
    let message = "Deactivated";
    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].userfilesdownloadable == false
    ) {
      option = 1;
      message = "Activated";
    }

    this.setState({ loadinguserfilesdownloadable: true });
    this.props.changeUserfilesdownloadable(
      session,
      option,
      settingData[0].id,
      (response) => {
        if (response.success) {
          this.props.fetchSettings(session, (res) => {
            this.setState({ loadinguserfilesdownloadable: false });
            this.props.showSuccess(message);
          });
        } else {
          this.setState({ loadinguserfilesdownloadable: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };
  handleSpeakerfilesdownloadable = () => {
    var { session, settingData } = this.props;
    let option = 0;
    let message = "Deactivated";
    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].speakerfilesdownloadable == false
    ) {
      option = 1;
      message = "Activated";
    }

    this.setState({ loadingspeakerfilesdownloadable: true });
    this.props.changeSpeakerfilesdownloadable(
      session,
      option,
      settingData[0].id,
      (response) => {
        if (response.success) {
          this.props.fetchSettings(session, (res) => {
            this.setState({ loadingspeakerfilesdownloadable: false });
            this.props.showSuccess(message);
          });
        } else {
          this.setState({ loadingspeakerfilesdownloadable: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };
  handleSponsorfilesdownloadable = () => {
    var { session, settingData } = this.props;
    let option = 0;
    let message = "Deactivated";
    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].sponsorfilesdownloadable == false
    ) {
      option = 1;
      message = "Activated";
    }

    this.setState({ loadingsponsorfilesdownloadable: true });
    this.props.changeSponsorfilesdownloadable(
      session,
      option,
      settingData[0].id,
      (response) => {
        if (response.success) {
          this.props.fetchSettings(session, (res) => {
            this.setState({ loadingsponsorfilesdownloadable: false });
            this.props.showSuccess(message);
          });
        } else {
          this.setState({ loadingsponsorfilesdownloadable: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };
  handleExhibitorfilesdownloadable = () => {
    var { session, settingData } = this.props;
    let option = 0;
    let message = "Deactivated";
    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].exhibitorfilesdownloadable == false
    ) {
      option = 1;
      message = "Activated";
    }

    this.setState({ loadingexhibitorfilesdownloadable: true });
    this.props.changeExhibitorfilesdownloadable(
      session,
      option,
      settingData[0].id,
      (response) => {
        if (response.success) {
          this.props.fetchSettings(session, (res) => {
            this.setState({ loadingexhibitorfilesdownloadable: false });
            this.props.showSuccess(message);
          });
        } else {
          this.setState({ loadingexhibitorfilesdownloadable: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };
  handleSessionfilesdownloadable = () => {
    var { session, settingData } = this.props;
    let option = 0;
    let message = "Deactivated";
    if (
      settingData &&
      settingData.length > 0 &&
      settingData[0].sessionfilesdownloadable == false
    ) {
      option = 1;
      message = "Activated";
    }

    this.setState({ loadingsessionfilesdownloadable: true });
    this.props.changeSessionfilesdownloadable(
      session,
      option,
      settingData[0].id,
      (response) => {
        if (response.success) {
          this.props.fetchSettings(session, (res) => {
            this.setState({ loadingsessionfilesdownloadable: false });
            this.props.showSuccess(message);
          });
        } else {
          this.setState({ loadingsessionfilesdownloadable: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  render() {
    let {
      timezone,
      loadingtimezone,
      loadingspeakesort,
      loadingsponsorsort,
      loadingexhibitorsort,
      loadinggalleryupload,
      loadingnotificationstatus,
      loadingappbottommenu,
      loadingsociallogin,
      loadingautologin,
      loadingloginmandatory,
      loadingmultiplelogin,
      notificationblocker,
      overviewscreenswitcher,
      eventcodelogin,
      loadingaccesswhitelabelapp,
      loadingwaitlistmode,
      loadingscheduleview,
      loadingspeakerview,
      loadingspeakerprofileshare,
      loadinguserfilesdownloadable,
      loadingspeakerfilesdownloadable,
      loadingsponsorfilesdownloadable,
      loadingexhibitorfilesdownloadable,
      loadingsessionfilesdownloadable,
    } = this.state;
    let { settingData, eventData, deviceSize, userModule } = this.props;
    // console.log("userModule :- ", userModule);
    // console.log("settingData :- ", settingData);

    let hrstyle = {
      // margin: "0px 0px 15px 0px",
      borderTop: "2px solid #e6edf3",
    };
    var curTime = "-:--";
    var usedTimeZone = "Asia/Calcutta";
    if (eventData && eventData.length > 0 && eventData[0].eventtimezone) {
      usedTimeZone = eventData[0].eventtimezone;
      var localTime = moment().tz(eventData[0].eventtimezone);
      curTime = localTime.format("h:mm A");
    }

    var disabledTimezoneButton = true;
    if (timezone != "") {
      usedTimeZone = timezone;
      var localTime = moment().tz(timezone);
      curTime = localTime.format("h:mm A");

      disabledTimezoneButton = false;
    }

    let speakersortaz =
      settingData &&
      settingData.length > 0 &&
      settingData[0].speakersort === "az"
        ? true
        : false;
    let sponsorsortaz =
      settingData &&
      settingData.length > 0 &&
      settingData[0].sponsorsort === "az"
        ? true
        : false;
    let exhibitorsortaz =
      settingData &&
      settingData.length > 0 &&
      settingData[0].exhibitorsort === "az"
        ? true
        : false;
    let galleryImage =
      settingData &&
      settingData.length > 0 &&
      settingData[0].galleryimage == true
        ? true
        : false;
    let notificationStatus =
      settingData &&
      settingData.length > 0 &&
      settingData[0].notificationonticketpurchase == true
        ? true
        : false;
    let appBottomMenu =
      settingData &&
      settingData.length > 0 &&
      settingData[0].isbottommenuactive == true
        ? true
        : false;
    let sociallogin =
      eventData && eventData.length > 0 && eventData[0].sociallogin == true
        ? true
        : false;
    let autoLogin =
      settingData && settingData.length > 0 && settingData[0].autologin == true
        ? true
        : false;
    let waitlist =
      settingData &&
      settingData.length > 0 &&
      settingData[0].waitlistmode == true
        ? true
        : false;
    let userfilesdownload =
      settingData &&
      settingData.length > 0 &&
      settingData[0].userfilesdownloadable == true
        ? true
        : false;
    let speakerfilesdownload =
      settingData &&
      settingData.length > 0 &&
      settingData[0].speakerfilesdownloadable == true
        ? true
        : false;
    let sponsorfilesdownload =
      settingData &&
      settingData.length > 0 &&
      settingData[0].sponsorfilesdownloadable == true
        ? true
        : false;
    let exhibitorfilesdownload =
      settingData &&
      settingData.length > 0 &&
      settingData[0].exhibitorfilesdownloadable == true
        ? true
        : false;
    let sessionfilesdownload =
      settingData &&
      settingData.length > 0 &&
      settingData[0].sessionfilesdownloadable == true
        ? true
        : false;
    let scheduleview =
      settingData &&
      settingData.length > 0 &&
      settingData[0].scheduleview == "grid"
        ? true
        : false;
    let loginMandatory =
      settingData &&
      settingData.length > 0 &&
      settingData[0].isloginmandatory == true
        ? true
        : false;
    let multipleLogin =
      settingData &&
      settingData.length > 0 &&
      settingData[0].allowmultiplelogin == true
        ? true
        : false;
    let pushblocker =
      settingData &&
      settingData.length > 0 &&
      settingData[0].notificationblocker == true
        ? true
        : false;
    let screenswitch =
      settingData &&
      settingData.length > 0 &&
      settingData[0].showquicklinksonhome == true
        ? true
        : false;
    let eventcodeloginstatus =
      settingData &&
      settingData.length > 0 &&
      settingData[0].eventcodelogin == true
        ? true
        : false;
    let accesswhitelabelappstatus =
      settingData &&
      settingData.length > 0 &&
      settingData[0].accesswhitelabelapp == true
        ? true
        : false;

    // This checking is used to allow admin for login mandatory option
    let allowLoginMandatory = true;
    if (
      (userModule &&
        userModule.length > 0 &&
        userModule[0].isenabled == false) ||
      (settingData &&
        settingData.length > 0 &&
        settingData[0].eventpolicytype === "public_without_reg")
    ) {
      allowLoginMandatory = false;
    }

    let eventArr = [
      "1776276494580538",
      "1780051130944916",
      "1782691812081309",
      "1783129439022785",
      "1789010270689790",
      "1791007189031350",
      "1791390659824958",
      "1791391939467344",
      "1791392138878701",
      "1791392353736111",
    ];
    let hideProfileScanSection = true;
    if (eventData.length > 0) {
      let eId = eventData[0].eventid.toString();

      if (eventArr.includes(eId)) {
        hideProfileScanSection = false;
      }
    }

    return (
      <div
        className="panel-body scrollable-content"
        style={{ height: deviceSize.height - 72 }}
      >
        <div
          className="settings-container"
          style={{ marginLeft: "auto", marginRight: "auto" }}
        >
          <span className="eventsetting-header">
            {LocaleStrings.basic_setting_user_group_header}
          </span>
          <div className="event-settingbox">
            <div className="col-md-12 d-flex">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div className="eventsettings-title">
                  {LocaleStrings.basic_setting_autologin_group}{" "}
                </div>
                <div className="eventsettings-description">
                  {
                    LocaleStrings.basic_setting_autologin_group_text_activate_or_not
                  }{" "}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                <label
                  className="switch-button-container"
                  style={{ marginRight: 0 }}
                >
                  <input
                    type="checkbox"
                    onChange={loadingautologin ? null : this.handleAutoLogin}
                    checked={autoLogin}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadingautologin ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
            <hr style={hrstyle} />
            <div className="col-md-12 d-flex">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div className="eventsettings-title">
                  {LocaleStrings.basic_setting_login_mandatory_group}{" "}
                </div>
                <div className="eventsettings-description">
                  {
                    LocaleStrings.basic_setting_login_mandatory_text_activate_or_not
                  }{" "}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                {allowLoginMandatory ? (
                  <label
                    className="switch-button-container"
                    style={{ marginRight: 0 }}
                  >
                    <input
                      type="checkbox"
                      onChange={
                        loadingloginmandatory ? null : this.handleMandatoryLogin
                      }
                      checked={loginMandatory}
                    />
                    <span
                      className={`switch-slider switch-round ${
                        loadingloginmandatory ? "cursor-wait" : ""
                      }`}
                    ></span>
                  </label>
                ) : (
                  <OverlayTrigger
                    key={`category`}
                    placement="right"
                    overlay={
                      <Tooltip
                        id={`tooltip-category`}
                        style={{ marginTop: "0px" }}
                      >
                        <div className="custom-text1-white-normal">
                          {
                            LocaleStrings.basic_setting_login_mandatory_validation_not_allow
                          }
                        </div>
                      </Tooltip>
                    }
                  >
                    <label
                      className="switch-button-container"
                      style={{ marginRight: 0 }}
                    >
                      <span className={`switch-slider switch-round`}></span>
                    </label>
                  </OverlayTrigger>
                )}
              </div>
            </div>
            <hr style={hrstyle} />
            <div className="col-md-12 d-flex">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div className="eventsettings-title">
                  {LocaleStrings.basic_setting_multiple_login_group}{" "}
                </div>
                <div className="eventsettings-description">
                  {
                    LocaleStrings.basic_setting_multiple_login_text_activate_or_not
                  }{" "}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                <label
                  className="switch-button-container"
                  style={{ marginRight: 0 }}
                >
                  <input
                    type="checkbox"
                    onChange={
                      loadingmultiplelogin ? null : this.handleMultipleLogin
                    }
                    checked={multipleLogin}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadingmultiplelogin ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
            <hr style={hrstyle} />
            <div className="col-md-12 d-flex">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div className="eventsettings-title">
                  {LocaleStrings.basic_setting_eventcode_login_group}{" "}
                </div>
                <div className="eventsettings-description">
                  {
                    LocaleStrings.basic_setting_eventcode_login_text_activate_or_not
                  }{" "}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                <label
                  className="switch-button-container"
                  style={{ marginRight: 0 }}
                >
                  <input
                    type="checkbox"
                    onChange={eventcodelogin ? null : this.handleEventCodeLogin}
                    checked={eventcodeloginstatus}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      eventcodelogin ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
            {/* <hr style={hrstyle} /> */}
          </div>
          <div className="eventsetting-header" style={{ marginTop: "20px" }}>
            {LocaleStrings.basic_setting_applayout_group_header}
          </div>
          <div className="event-settingbox">
            <div className="col-md-12 d-flex">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div className="eventsettings-title">
                  {LocaleStrings.basic_setting_gallery_pic_upload_group}{" "}
                </div>
                <div className="eventsettings-description">
                  {
                    LocaleStrings.basic_setting_gallery_pic_upload_group_text_uploadby
                  }{" "}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                <label
                  className="switch-button-container"
                  style={{ marginRight: 0 }}
                >
                  <input
                    type="checkbox"
                    onChange={
                      loadinggalleryupload ? null : this.handleGalleryUpload
                    }
                    checked={galleryImage}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadinggalleryupload ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
            <hr style={hrstyle} />
            <div className="col-md-12 d-flex">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div className="eventsettings-title">
                  {LocaleStrings.basic_setting_app_bottom_menu_group}{" "}
                </div>
                <div className="eventsettings-description">
                  {
                    LocaleStrings.basic_setting_app_bottom_menu_group_text_activate_or_not
                  }{" "}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                <label
                  className="switch-button-container"
                  style={{ marginRight: 0 }}
                >
                  <input
                    type="checkbox"
                    onChange={
                      loadingappbottommenu ? null : this.handleAppBottomMenu
                    }
                    checked={appBottomMenu}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadingappbottommenu ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
            <hr style={hrstyle} />
            <div className="col-md-12 d-flex">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div className="eventsettings-title">
                  {LocaleStrings.basic_setting_overview_screen_switcher_group}{" "}
                </div>
                <div className="eventsettings-description">
                  {
                    LocaleStrings.basic_setting_overview_screen_switcher_text_activate_or_not
                  }{" "}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                <label
                  className="switch-button-container"
                  style={{ marginRight: 0 }}
                >
                  <input
                    type="checkbox"
                    onChange={
                      overviewscreenswitcher ? null : this.handleScreenSwitcher
                    }
                    checked={screenswitch}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      overviewscreenswitcher ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
            <hr style={hrstyle} />
            <div className="col-md-12 d-flex">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div className="eventsettings-title">
                  {LocaleStrings.basic_setting_access_whitelabel_app_group}{" "}
                </div>
                <div className="eventsettings-description">
                  {
                    LocaleStrings.basic_setting_whitelabel_app_text_access_or_not
                  }{" "}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                <label
                  className="switch-button-container"
                  style={{ marginRight: 0 }}
                >
                  <input
                    type="checkbox"
                    onChange={
                      loadingaccesswhitelabelapp
                        ? null
                        : this.handleWhiteLabelAppAccess
                    }
                    checked={accesswhitelabelappstatus}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadingaccesswhitelabelapp ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
            <hr style={hrstyle} />
            <div className="col-md-12 d-flex">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div className="eventsettings-title">
                  {LocaleStrings.basic_setting_scheduleview_heading}
                </div>
                <div className="eventsettings-description">
                  {LocaleStrings.basic_setting_scheduleview_subHeading}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                <label
                  className="switch-button-container"
                  style={{ marginRight: 0 }}
                >
                  <input
                    type="checkbox"
                    onChange={
                      loadingscheduleview ? null : this.handleScheduleStatus
                    }
                    checked={scheduleview}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadingscheduleview ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
            <hr style={hrstyle} />
            <div className="col-md-12 d-flex">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div className="eventsettings-title">
                  {LocaleStrings.basic_setting_speakerview_heading}
                </div>
                <div className="eventsettings-description">
                  {LocaleStrings.basic_setting_speakerview_subheading}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                <label
                  className="switch-button-container"
                  style={{ marginRight: 0 }}
                >
                  <input
                    type="checkbox"
                    onChange={
                      loadingspeakerview ? null : this.handleSpeakerView
                    }
                    checked={
                      settingData &&
                      settingData.length > 0 &&
                      settingData[0].speakerlistview == true
                        ? true
                        : false
                    }
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadingspeakerview ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
          </div>

          {/* Sorting settings */}
          <div className="eventsetting-header" style={{ marginTop: "20px" }}>
            {LocaleStrings.event_setting_sorting_group_header}
          </div>
          <div className="event-settingbox">
            <div className="col-md-12 d-flex">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div className="eventsettings-title">
                  {LocaleStrings.event_setting_speaker_sorting_group}
                </div>
                <div className="eventsettings-description">
                  {LocaleStrings.event_setting_speaker_sorting_group_subtitle}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                <label
                  className="switch-button-container"
                  style={{ marginRight: 0 }}
                >
                  <input
                    type="checkbox"
                    onChange={loadingspeakesort ? null : this.handleSpeakerSort}
                    checked={speakersortaz}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadingspeakesort ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
            <hr style={hrstyle} />
            <div className="col-md-12 d-flex">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div className="eventsettings-title">
                  {LocaleStrings.event_setting_sponsor_sorting_group}{" "}
                </div>
                <div className="eventsettings-description">
                  {LocaleStrings.event_setting_sponsor_sorting_group_subtitle}{" "}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                <label
                  className="switch-button-container"
                  style={{ marginRight: 0 }}
                >
                  <input
                    type="checkbox"
                    onChange={
                      loadingsponsorsort ? null : this.handleSponsorSort
                    }
                    checked={sponsorsortaz}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadingsponsorsort ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
            <hr style={hrstyle} />
            <div className="col-md-12 d-flex">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div className="eventsettings-title">
                  {LocaleStrings.event_setting_exhibitor_sorting_group}{" "}
                </div>
                <div className="eventsettings-description">
                  {LocaleStrings.event_setting_exhibitor_sorting_group_subtitle}{" "}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                <label
                  className="switch-button-container"
                  style={{ marginRight: 0 }}
                >
                  <input
                    type="checkbox"
                    onChange={
                      loadingexhibitorsort ? null : this.handleExhibitorSort
                    }
                    checked={exhibitorsortaz}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadingexhibitorsort ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
          </div>

          <div className="eventsetting-header" style={{ marginTop: "20px" }}>
            {LocaleStrings.basic_setting_profile_share_group_header}
          </div>
          <div className="event-settingbox">
            <div className="col-md-12 d-flex">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div className="eventsettings-title">
                  {LocaleStrings.basic_setting_speaker_profile_share_heading}
                </div>
                <div className="eventsettings-description">
                  {LocaleStrings.basic_setting_speaker_profile_share_subheading}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                <label
                  className="switch-button-container"
                  style={{ marginRight: 0 }}
                >
                  <input
                    type="checkbox"
                    onChange={
                      loadingspeakerprofileshare
                        ? null
                        : this.handleSpeakerProfileShare
                    }
                    checked={
                      settingData &&
                      settingData.length > 0 &&
                      settingData[0].speakerprofileshare == true
                        ? true
                        : false
                    }
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadingspeakerprofileshare ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
          </div>

          {/* Ticketing setting */}
          <div className="eventsetting-header" style={{ marginTop: "20px" }}>
            {LocaleStrings.basic_setting_ticketing_group_header}
          </div>
          <div className="event-settingbox">
            <div className="col-md-12 d-flex">
              {/* <label className="setting-company-buttons-section-heading">
              {LocaleStrings.basic_setting_notification_group}
            </label> */}

              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div className="eventsettings-title">
                  {LocaleStrings.basic_setting_notification_group}{" "}
                </div>
                <div className="eventsettings-description">
                  {
                    LocaleStrings.basic_setting_notification_group_activate_or_not
                  }{" "}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                <label
                  className="switch-button-container"
                  style={{ marginRight: 0 }}
                >
                  <input
                    type="checkbox"
                    onChange={
                      loadingnotificationstatus ? null : this.handleNotification
                    }
                    checked={notificationStatus}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadingnotificationstatus ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
            <hr style={hrstyle} />
            <div className="col-md-12 d-flex">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div className="eventsettings-title">
                  {LocaleStrings.basic_setting_waitlist_heading}
                </div>
                <div className="eventsettings-description">
                  {LocaleStrings.basic_setting_waitlist_subHeading}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                <label
                  className="switch-button-container"
                  style={{ marginRight: 0 }}
                >
                  <input
                    type="checkbox"
                    onChange={
                      loadingwaitlistmode ? null : this.handleWaitlistMode
                    }
                    checked={waitlist}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadingwaitlistmode ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
          </div>

          {/* Profile scan setting */}
          {hideProfileScanSection === false ? (
            <>
              {/* Profile sharing setting */}
              <div
                className="eventsetting-header"
                style={{ marginTop: "20px" }}
              >
                {"Profile Scanning"}
              </div>
              <div className="event-settingbox">
                <div className="col-md-12 d-flex">
                  <div className="col-md-9" style={{ marginTop: "5px" }}>
                    <div>
                      <span className="eventsettings-title">
                        {"Enable Scanning"}
                      </span>
                      <span className="text-custom-danger ml-10">
                        (deprecated will be removed soon)
                      </span>
                    </div>
                    <div className="eventsettings-description">
                      {
                        "Switching it on will allow a user to scan other user's qr"
                      }
                    </div>
                  </div>
                  <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                    <label
                      className="switch-button-container"
                      style={{ marginRight: 0 }}
                    >
                      <input type="checkbox" checked={true} />
                      <span
                        className={`switch-slider switch-round cursor-disbaled`}
                      ></span>
                    </label>
                  </div>
                </div>
              </div>
            </>
          ) : (
            ""
          )}

          {/* File Download persmission section */}
          <div className="eventsetting-header" style={{ marginTop: "20px" }}>
            {LocaleStrings.basic_setting_file_group_header}
          </div>
          <div className="event-settingbox">
            <div className="col-md-12 d-flex">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div className="eventsettings-title">
                  {LocaleStrings.basic_setting_userfile_download_title}
                </div>
                <div className="eventsettings-description">
                  {LocaleStrings.basic_setting_userfile_download_description}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                <label
                  className="switch-button-container"
                  style={{ marginRight: 0 }}
                >
                  <input
                    type="checkbox"
                    onChange={
                      loadinguserfilesdownloadable
                        ? null
                        : this.handleUserfilesdownloadable
                    }
                    checked={userfilesdownload}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadinguserfilesdownloadable ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
            <hr style={hrstyle} />
            <div className="col-md-12 d-flex">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div className="eventsettings-title">
                  {LocaleStrings.basic_setting_speakerfile_download_title}
                </div>
                <div className="eventsettings-description">
                  {LocaleStrings.basic_setting_speakerfile_download_description}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                <label
                  className="switch-button-container"
                  style={{ marginRight: 0 }}
                >
                  <input
                    type="checkbox"
                    onChange={
                      loadingspeakerfilesdownloadable
                        ? null
                        : this.handleSpeakerfilesdownloadable
                    }
                    checked={speakerfilesdownload}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadingspeakerfilesdownloadable ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
            <hr style={hrstyle} />
            <div className="col-md-12 d-flex">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div className="eventsettings-title">
                  {LocaleStrings.basic_setting_sponsorfile_download_title}
                </div>
                <div className="eventsettings-description">
                  {LocaleStrings.basic_setting_sponsorfile_download_description}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                <label
                  className="switch-button-container"
                  style={{ marginRight: 0 }}
                >
                  <input
                    type="checkbox"
                    onChange={
                      loadingsponsorfilesdownloadable
                        ? null
                        : this.handleSponsorfilesdownloadable
                    }
                    checked={sponsorfilesdownload}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadingsponsorfilesdownloadable ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
            <hr style={hrstyle} />
            <div className="col-md-12 d-flex">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div className="eventsettings-title">
                  {LocaleStrings.basic_setting_exhibitorfile_download_title}
                </div>
                <div className="eventsettings-description">
                  {
                    LocaleStrings.basic_setting_exhibitorfile_download_description
                  }
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                <label
                  className="switch-button-container"
                  style={{ marginRight: 0 }}
                >
                  <input
                    type="checkbox"
                    onChange={
                      loadingexhibitorfilesdownloadable
                        ? null
                        : this.handleExhibitorfilesdownloadable
                    }
                    checked={exhibitorfilesdownload}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadingexhibitorfilesdownloadable ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
            <hr style={hrstyle} />
            <div className="col-md-12 d-flex">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div className="eventsettings-title">
                  {LocaleStrings.basic_setting_sessionfile_download_title}
                </div>
                <div className="eventsettings-description">
                  {LocaleStrings.basic_setting_sessionfile_download_description}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                <label
                  className="switch-button-container"
                  style={{ marginRight: 0 }}
                >
                  <input
                    type="checkbox"
                    onChange={
                      loadingsessionfilesdownloadable
                        ? null
                        : this.handleSessionfilesdownloadable
                    }
                    checked={sessionfilesdownload}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadingsessionfilesdownloadable ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
          </div>

          {/* <div className="eventsetting-header" style={{marginTop:'20px'}}>{LocaleStrings.basic_setting_other_group_header}</div>
        <div className="event-settingbox">
        <div className="col-md-12 d-flex">

              <div className="col-md-9" style={{ marginTop: "5px" }}>
              <div className="eventsettings-title">
                 {LocaleStrings.basic_setting_scheduleview_heading}
                </div>
                <div className="eventsettings-description">
                {LocaleStrings.basic_setting_scheduleview_subHeading}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p text-end">
                <label className="switch-button-container" style={{marginRight:0}}>
                  <input
                    type="checkbox"
                    onChange={
                      loadingscheduleview ? null : this.handleScheduleStatus
                    }
                    checked={scheduleview}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadingscheduleview ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
          </div>
        </div> */}
          {/* <div className="row">
          {DEVELOPMENT_TYPE === "koachify" ? (
            <div className="col-md-12">
              <label className="setting-company-buttons-section-heading">
                {LocaleStrings.event_setting_event_timezone_group}
              </label>
              <hr style={hrstyle} />
              <div className="row">
                <div className="col-md-9 col-xs-12">
                  <TimeZoneSelect
                    defaultTimezone={usedTimeZone}
                    timezonecallback={this.updatetimezone}
                  />
                  <div className="currenttime">{`${LocaleStrings.general_form_label_event_timezone_time_message} ${curTime}`}</div>
                </div>
                <div className="col-md-3 col-xs-12 text-center">
                  <Button
                    onClick={this.handleEventTimezone}
                    className="btn-custom-blue"
                    loading={loadingtimezone}
                    disabled={disabledTimezoneButton}
                    type="button"
                  >
                    {LocaleStrings.button_save}
                  </Button>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="col-md-12">
            <label className="setting-company-buttons-section-heading">
              {LocaleStrings.event_setting_speaker_sorting_group}
            </label>
            <div className="row">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div>
                  {LocaleStrings.event_setting_speaker_sorting_group_subtitle}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p">
                <label className="switch-button-container">
                  <input
                    type="checkbox"
                    onChange={loadingspeakesort ? null : this.handleSpeakerSort}
                    checked={speakersortaz}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadingspeakesort ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
            <hr style={hrstyle} />
          </div>
          {DEVELOPMENT_TYPE === "eventify" ? (
            <div className="col-md-12">
              <label className="setting-company-buttons-section-heading">
                {LocaleStrings.event_setting_sponsor_sorting_group}
              </label>
              <div className="row">
                <div className="col-md-9" style={{ marginTop: "5px" }}>
                  <div>
                    {LocaleStrings.event_setting_sponsor_sorting_group_subtitle}{" "}
                  </div>
                </div>
                <div className="col-md-3 col-xs-12 settings-slider-p">
                  <label className="switch-button-container">
                    <input
                      type="checkbox"
                      onChange={
                        loadingsponsorsort ? null : this.handleSponsorSort
                      }
                      checked={sponsorsortaz}
                    />
                    <span
                      className={`switch-slider switch-round ${
                        loadingsponsorsort ? "cursor-wait" : ""
                      }`}
                    ></span>
                  </label>
                </div>
              </div>
              <hr style={hrstyle} />
            </div>
          ) : (
            ""
          )}
          {DEVELOPMENT_TYPE === "eventify" ? (
            <div className="col-md-12">
              <label className="setting-company-buttons-section-heading">
                {LocaleStrings.event_setting_exhibitor_sorting_group}
              </label>
              <div className="row">
                <div className="col-md-9" style={{ marginTop: "5px" }}>
                  <div>
                    {
                      LocaleStrings.event_setting_exhibitor_sorting_group_subtitle
                    }{" "}
                  </div>
                </div>
                <div className="col-md-3 col-xs-12 settings-slider-p">
                  <label className="switch-button-container">
                    <input
                      type="checkbox"
                      onChange={
                        loadingexhibitorsort ? null : this.handleExhibitorSort
                      }
                      checked={exhibitorsortaz}
                    />
                    <span
                      className={`switch-slider switch-round ${
                        loadingexhibitorsort ? "cursor-wait" : ""
                      }`}
                    ></span>
                  </label>
                </div>
              </div>
              <hr style={hrstyle} />
            </div>
          ) : (
            ""
          )}
          <div className="col-md-12">
            <label className="setting-company-buttons-section-heading">
              {LocaleStrings.basic_setting_gallery_pic_upload_group}
            </label>
            <div className="row">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div>
                  {
                    LocaleStrings.basic_setting_gallery_pic_upload_group_text_uploadby
                  }{" "}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p">
                <label className="switch-button-container">
                  <input
                    type="checkbox"
                    onChange={
                      loadinggalleryupload ? null : this.handleGalleryUpload
                    }
                    checked={galleryImage}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadinggalleryupload ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
            <hr style={hrstyle} />
          </div>

          <div className="col-md-12">
            <label className="setting-company-buttons-section-heading">
              {LocaleStrings.basic_setting_notification_group}
            </label>
            <div className="row">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div>
                  {
                    LocaleStrings.basic_setting_notification_group_activate_or_not
                  }{" "}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p">
                <label className="switch-button-container">
                  <input
                    type="checkbox"
                    onChange={
                      loadingnotificationstatus ? null : this.handleNotification
                    }
                    checked={notificationStatus}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadingnotificationstatus ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
            <hr style={hrstyle} />
          </div>
          {DEVELOPMENT_TYPE === "koachify" ? (
            ""
          ) : (
            <div className="col-md-12">
              <label className="setting-company-buttons-section-heading">
                {LocaleStrings.basic_setting_app_bottom_menu_group}
              </label>
              <div className="row">
                <div className="col-md-9" style={{ marginTop: "5px" }}>
                  <div>
                    {
                      LocaleStrings.basic_setting_app_bottom_menu_group_text_activate_or_not
                    }{" "}
                  </div>
                </div>
                <div className="col-md-3 col-xs-12 settings-slider-p">
                  <label className="switch-button-container">
                    <input
                      type="checkbox"
                      onChange={
                        loadingappbottommenu ? null : this.handleAppBottomMenu
                      }
                      checked={appBottomMenu}
                    />
                    <span
                      className={`switch-slider switch-round ${
                        loadingappbottommenu ? "cursor-wait" : ""
                      }`}
                    ></span>
                  </label>
                </div>
              </div>
              <hr style={hrstyle} />
            </div>
          )}
          {DEVELOPMENT_TYPE === "koachify" ? (
            ""
          ) : (
            <div className="col-md-12">
              <label className="setting-company-buttons-section-heading">
                {LocaleStrings.basic_setting_autologin_group}
              </label>
              <div className="row">
                <div className="col-md-9" style={{ marginTop: "5px" }}>
                  <div>
                    {
                      LocaleStrings.basic_setting_autologin_group_text_activate_or_not
                    }{" "}
                  </div>
                </div>
                <div className="col-md-3 col-xs-12 settings-slider-p">
                  <label className="switch-button-container">
                    <input
                      type="checkbox"
                      onChange={loadingautologin ? null : this.handleAutoLogin}
                      checked={autoLogin}
                    />
                    <span
                      className={`switch-slider switch-round ${
                        loadingautologin ? "cursor-wait" : ""
                      }`}
                    ></span>
                  </label>
                </div>
              </div>
              <hr style={hrstyle} />
            </div>
          )}
          {DEVELOPMENT_TYPE === "koachify" ? (
            ""
          ) : (
            <div className="col-md-12">
              <label className="setting-company-buttons-section-heading">
                {LocaleStrings.basic_setting_login_mandatory_group}
              </label>
              <div className="row">
                <div className="col-md-9" style={{ marginTop: "5px" }}>
                  <div>
                    {
                      LocaleStrings.basic_setting_login_mandatory_text_activate_or_not
                    }{" "}
                  </div>
                </div>
                <div className="col-md-3 col-xs-12 settings-slider-p">
                  <label className="switch-button-container">
                    <input
                      type="checkbox"
                      onChange={
                        loadingloginmandatory ? null : this.handleMandatoryLogin
                      }
                      checked={loginMandatory}
                    />
                    <span
                      className={`switch-slider switch-round ${
                        loadingloginmandatory ? "cursor-wait" : ""
                      }`}
                    ></span>
                  </label>
                </div>
              </div>
              <hr style={hrstyle} />
            </div>
          )}
          <div className="col-md-12">
            <label className="setting-company-buttons-section-heading">
              {LocaleStrings.basic_setting_multiple_login_group}
            </label>
            <div className="row">
              <div className="col-md-9" style={{ marginTop: "5px" }}>
                <div>
                  {
                    LocaleStrings.basic_setting_multiple_login_text_activate_or_not
                  }{" "}
                </div>
              </div>
              <div className="col-md-3 col-xs-12 settings-slider-p">
                <label className="switch-button-container">
                  <input
                    type="checkbox"
                    onChange={
                      loadingmultiplelogin ? null : this.handleMultipleLogin
                    }
                    checked={multipleLogin}
                  />
                  <span
                    className={`switch-slider switch-round ${
                      loadingmultiplelogin ? "cursor-wait" : ""
                    }`}
                  ></span>
                </label>
              </div>
            </div>
            <hr style={hrstyle} />
          </div>
         
          {DEVELOPMENT_TYPE === "koachify" ? (
            ""
          ) : (
            <div className="col-md-12">
              <label className="setting-company-buttons-section-heading">
                {LocaleStrings.basic_setting_overview_screen_switcher_group}
              </label>
              <div className="row">
                <div className="col-md-9" style={{ marginTop: "5px" }}>
                  <div>
                    {
                      LocaleStrings.basic_setting_overview_screen_switcher_text_activate_or_not
                    }{" "}
                  </div>
                </div>
                <div className="col-md-3 col-xs-12 settings-slider-p">
                  <label className="switch-button-container">
                    <input
                      type="checkbox"
                      onChange={
                        overviewscreenswitcher
                          ? null
                          : this.handleScreenSwitcher
                      }
                      checked={screenswitch}
                    />
                    <span
                      className={`switch-slider switch-round ${
                        overviewscreenswitcher ? "cursor-wait" : ""
                      }`}
                    ></span>
                  </label>
                </div>
              </div>
              <hr style={hrstyle} />
            </div>
          )}
          {DEVELOPMENT_TYPE === "koachify" ? (
            ""
          ) : (
            <div className="col-md-12">
              <label className="setting-company-buttons-section-heading">
                {LocaleStrings.basic_setting_eventcode_login_group}
              </label>
              <div className="row">
                <div className="col-md-9" style={{ marginTop: "5px" }}>
                  <div>
                    {
                      LocaleStrings.basic_setting_eventcode_login_text_activate_or_not
                    }{" "}
                  </div>
                </div>
                <div className="col-md-3 col-xs-12 settings-slider-p">
                  <label className="switch-button-container">
                    <input
                      type="checkbox"
                      onChange={
                        eventcodelogin ? null : this.handleEventCodeLogin
                      }
                      checked={eventcodeloginstatus}
                    />
                    <span
                      className={`switch-slider switch-round ${
                        eventcodelogin ? "cursor-wait" : ""
                      }`}
                    ></span>
                  </label>
                </div>
              </div>
              <hr style={hrstyle} />
            </div>
          )}
          {DEVELOPMENT_TYPE === "koachify" ? (
            ""
          ) : (
            <div className="col-md-12">
              <label className="setting-company-buttons-section-heading">
                {LocaleStrings.basic_setting_access_whitelabel_app_group}
              </label>
              <div className="row">
                <div className="col-md-9" style={{ marginTop: "5px" }}>
                  <div>
                    {
                      LocaleStrings.basic_setting_whitelabel_app_text_access_or_not
                    }{" "}
                  </div>
                </div>
                <div className="col-md-3 col-xs-12 settings-slider-p">
                  <label className="switch-button-container">
                    <input
                      type="checkbox"
                      onChange={
                        loadingaccesswhitelabelapp
                          ? null
                          : this.handleWhiteLabelAppAccess
                      }
                      checked={accesswhitelabelappstatus}
                    />
                    <span
                      className={`switch-slider switch-round ${
                        loadingaccesswhitelabelapp ? "cursor-wait" : ""
                      }`}
                    ></span>
                  </label>
                </div>
              </div>
              <hr style={hrstyle} />
            </div>
          )}
          {DEVELOPMENT_TYPE === "koachify" ? (
            ""
          ) : (
            <div className="col-md-12">
              <label className="setting-company-buttons-section-heading">
                {LocaleStrings.basic_setting_waitlist_heading}
              </label>
              <div className="row">
                <div className="col-md-9" style={{ marginTop: "5px" }}>
                  <div>{LocaleStrings.basic_setting_waitlist_subHeading}</div>
                </div>
                <div className="col-md-3 col-xs-12 settings-slider-p">
                  <label className="switch-button-container">
                    <input
                      type="checkbox"
                      onChange={
                        loadingwaitlistmode ? null : this.handleWaitlistMode
                      }
                      checked={waitlist}
                    />
                    <span
                      className={`switch-slider switch-round ${
                        loadingwaitlistmode ? "cursor-wait" : ""
                      }`}
                    ></span>
                  </label>
                </div>
              </div>
              <hr style={hrstyle} />
            </div>
          )}
        </div> */}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let userModule = [{ isenabled: false }];
  if (state.actionAppModules && state.actionAppModules.length > 0) {
    userModule = _.filter(state.actionAppModules, (obj) => {
      return obj.bsClass == "users";
    });
  }

  return {
    session: state.session,
    deviceSize: state.deviceSize,
    settingData: state.SettingData.resource,
    eventData: state.eventData,
    userModule,
  };
}

export default connect(mapStateToProps, {
  fetchSettings,
  updatedEventSetting,
  updateTimeZone,
  changeSpeakerSort,
  changeExhibitorSort,
  changeSponsorSort,
  changeGalleryUploadPermission,
  changeNotificationStatus,
  changeAppBottomMenuStatus,
  changeSocialLogin,
  fetchEvent,
  changeAutologinStatus,
  changeloginMandatoryStatus,
  changeMultipleLoginStatus,
  updateEventSettingOption,
  showError,
  showSuccess,
  changeWaitlistmode,
  changeScheduleview,
  changeUserfilesdownloadable,
  changeSpeakerfilesdownloadable,
  changeSponsorfilesdownloadable,
  changeExhibitorfilesdownloadable,
  changeSessionfilesdownloadable,
  fetchFeature,
})(EventSetting);
